import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PreinvoiceModel } from '../invoice/preinvoice/preinvoice.model';
import { InvoiceLineModel } from '../invoice/preinvoice/invoiceline.model';
import { CoreComponent } from '../../core/header/core.component';
import { AccountsAndTaxesModel } from '../invoice/preinvoice/accountsandtaxes.model';
import { BankAccountModel } from '../finanzas/bancos/bankaccount.model';
import { UserCompanyService } from '../user/usercompany/usercompany.service';
import { ActualSelected, Utils } from '../../shared/utils';
import { UserContactService } from '../user/usercontact/usercontact.service';
import { PreinvoiceService } from '../invoice/preinvoice/preinvoice.service';
import { ContactModel } from '../contact/contact/contact.model';
import { ContactService } from '../contact/contact/contact.service';
import { ActivityService } from '../user/activity/activity.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConceptModel } from '../concept/concept/concept.model';
import { ConceptService } from '../concept/concept/concept.service';
import { TaxCalculator } from '../../shared/taxCalculator';
import { AppointmentDetailsDialogComponent } from './appointment-details-dialog.component';
import { TicketModel } from '../invoice/tickets/ticket.model';
import { TicketLineModel } from '../invoice/tickets/ticketline.model';
import { TicketService } from '../invoice/tickets/ticket.service';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'ticket-appointment-wrapper',
    templateUrl: './ticket-appointment-wrapper.component.html',
    standalone: false
})

export class TicketAppointmentWrapperComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<AppointmentDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userCompanyService: UserCompanyService,
        private userContactService: UserContactService,
        private ticketService: TicketService,
        private contactService: ContactService,
        private activityService: ActivityService,
        private conceptService: ConceptService,
        public snackBar: MatSnackBar,
        private router: Router,
        private taxCalculator: TaxCalculator
    ) { }

    ticket: TicketModel = new TicketModel();
    accountsAndTaxes: AccountsAndTaxesModel;
    contactList: ContactModel[] = this.data.contacts;
    bankAccounts: BankAccountModel[];
    working = true;
    ready = true;

    public displayError(error: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10500;
        this.snackBar.open(error, '', options);
    }

    ngOnInit(): void {
        let receiver: ContactModel = new ContactModel();
        let concept: ConceptModel = new ConceptModel();
        this.contactService.loadData(this.data.newEvent.contactUid).then(response => {
            receiver = response;
            this.ticket.receiverUid = receiver.uid;
            this.ticket.receiverName = receiver.companyName;

            this.ticket.ticketLines = new Array<TicketLineModel>();
            this.ticket.activityUid = ActualSelected.activitySelected;

            this.userCompanyService.loadData().then(userCompany => {
                this.ticket.companyName = userCompany.companyName;
                this.ticket.vatNumber = userCompany.vatNumber;
                this.userContactService.loadData().then(userContact => {

                    if (Utils.IsNullOrEmpty(this.ticket.address)) {
                        this.ticket.address = userContact.address;
                    }

                    if (Utils.IsNullOrEmpty(this.ticket.postalCode)) {
                        this.ticket.postalCode = userContact.postalCode;
                    }

                    if (Utils.IsNullOrEmpty(this.ticket.location)) {
                        this.ticket.location = userContact.location;
                    }

                    if (Utils.IsNullOrEmpty(this.ticket.country)) {
                        this.ticket.country = userContact.country;
                    }

                    if (Utils.IsNullOrEmpty(this.ticket.state)) {
                        this.ticket.state = userContact.state;
                    }

                })
                this.ticketService.accountsAndTaxesData().then(accountsAndTaxes => {
                    this.accountsAndTaxes = accountsAndTaxes;
                    this.activityService.loadData(ActualSelected.activitySelected).then(response => {
                        this.ticket.ticketNumber = response.ticketNumber;
                        this.ticket.entranceAccount = response.ticketAccountEntrance;
                        this.ticket.expenseAccount = response.ticketAccountExpense;

                        if (this.data.newEvent.conceptUid != '00000000-0000-0000-0000-000000000000') {
                            this.conceptService.loadData(this.data.newEvent.conceptUid).then(response => {
                                concept = response;
                                const line = new TicketLineModel();
                                line.product = concept.name;
                                line.conceptUid = concept.uid;
                                line.taxes = concept.taxes;
                                line.quantity = 1;
                                line.unityAmount = concept.price;
                                line.totalLine = this.calcularTotalesLinea(line);
                                this.ticket.ticketLines.push(line);
                                this.working = false;
                            })
                        } else {
                            const line = new TicketLineModel();
                            const raw = this.data.newEvent.observations || '';
                            const index = raw.indexOf('Concepto libre:');
                            let conceptoLibre = '';
                            if (index !== -1) {
                                conceptoLibre = raw.substring(index + 'Concepto libre:'.length).trim();
                            }
                            line.product = conceptoLibre;
                            this.ticket.ticketLines.push(line);
                            this.working = false;
                        }

                    })
                });

            });
        });

    }

    public returnToIndex(): void {
        this.router.navigate(['invoice/ticket']);
    }

    saveData = function (ticket: TicketModel) {
        this.ready = false;
        this.ticket.fiscalYear = ActualSelected.yearSelected;
        this.ticket.activityUid = ActualSelected.activitySelected;
        ticket.activityUid = this.ticket.activityUid;
        this.activityService.loadData(ticket.activityUid).then(response => {
            this.activity = response;
            this.activity.ticketNumber = ticket.ticketNumber;
        });

        this.ticketService.addData(ticket)
            .then(ticket => {
                this.generatePdf(ticket.uid);
                this.ticketService.saveRequestUpdateValue(false);
                this.ready = true;
                this.dialogRef.close();
                this.returnToIndex();
            })
            .catch(errors => {
                if (errors && errors.error && errors.error.message) {
                    this.displayInfo(errors.error.message);
                } else {
                    this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
                }
                this.ticketService.saveRequestUpdateValue(false);
            })

    }

    private generatePdf(uid: string) {
        this.ticketService.pdf(uid).then(response => {
            FileSaver.saveAs(response, Utils.GetPdfName("Ticket_" + this.ticket.ticketNumber));
        })
    }

    calcularTotalesLinea(ticketLine) {
        ticketLine.totalLine = this.taxCalculator.calcularTotalLinea(ticketLine);
        return ticketLine.totalLine;
    }
}
